// extracted by mini-css-extract-plugin
export default {"DropdownMenu":"DropdownMenu_DropdownMenu__xB9Bz"};